export default __webpack_public_path__ + "static/Banner-Juvederm-1-cf06050853c0a235c05b1e10330fe48c.jpg";